import React from 'react';

import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

import mapIcon from 'components/shared/images/map_icon.png';

import Text from '../Typography/Text';
import styles from './index.module.css';
import MapPoints from './MapPoints';
import mapStyles from './mapStyles';

const defaultProps = {
  containerStyle: {
    width: '100%',
    height: '230px',
  },
  onClickMap: () => null,
};

const apiKey = process.env.REACT_APP_GOOGLE_MAP;

function MapBlock(props) {
  const { google, coords = [], onClickMap, containerStyle, points = [], loaded, onReady = () => {} } = props;
  const { width = '100%', height = '23rem' } = containerStyle;
  const isError = loaded && !google;

  const mapLoaded = (mapProps, map) => {
    map.setOptions({
      styles: mapStyles,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        mapTypeIds: ['roadmap', 'hybrid'],
      },
      streetViewControl: false,
    });

    map.addListener('tilesloaded', () => {
      setTimeout(onReady, 1000);
    });
  };

  const handleClickMap = async (e, map, clickEvent) => {
    map.panTo({
      lat: clickEvent.latLng.lat(),
      lng: clickEvent.latLng.lng(),
    });
    await new Promise((res) => {
      setTimeout(res, 300);
    });
    onClickMap(e, map, clickEvent);
  };

  if (isError) {
    return (
      <div style={{ width, height, position: 'relative' }}>
        <div className={styles.errorMessageContainer}>
          <Text type="danger">Map failed to load</Text>
        </div>
      </div>
    );
  }

  if (points?.length > 0) return <MapPoints {...props} mapLoaded={mapLoaded} />;

  return (
    <div style={{ width, height, position: 'relative' }}>
      <Map
        center={coords}
        initialCenter={coords}
        style={containerStyle}
        google={google}
        zoom={6}
        zoomControl
        onReady={(mapProps, map) => mapLoaded(mapProps, map)}
        onClick={handleClickMap}
        gestureHandling="cooperative"
      >
        <Marker
          position={coords}
          icon={{
            url: mapIcon,
            scaledSize: new google.maps.Size(21, 31),
          }}
        />
      </Map>
    </div>
  );
}

MapBlock.defaultProps = defaultProps;

export default React.memo(
  GoogleApiWrapper({
    apiKey,
  })(MapBlock),
  areEqual,
);

function areEqual(prev, next) {
  return prev?.coords?.lat === next?.coords?.lng && prev?.coords?.lng === next?.coords?.lng;
}
